import QuestionMarkIcon from "@/assets/campaign/4D64FC_question_icon.svg?react";
import ChevronRight from "@/assets/colorable/right_chevron.svg?react";
import clsxm from "@/lib/clsxm";
import {type FC, type RefObject} from "react";

const ProfileSeparator: FC<{
  ref?: RefObject<HTMLDivElement | null>;
  icon: string;
  text: string;
  iconContainerClassName?: string;
  iconClassName?: string;
  onTooltipClick?: () => void;
  isToggleable?: boolean;
  isToggled?: boolean;
  onToggle?(): void;
}> = ({
  ref,
  icon,
  text,
  iconContainerClassName,
  iconClassName,
  onTooltipClick,
  isToggleable = false,
  isToggled = false,
  onToggle,
}) => {
  return (
    <div ref={ref} className="flex scroll-mt-24 flex-row items-center justify-center gap-8">
      <div className="bg-neutral-grey-light h-[1px] flex-1" />
      <div
        className={`flex flex-row items-center justify-center gap-2 rounded-full border-1 px-3 py-1 ${isToggleable ? "cursor-pointer" : ""}`}
        onClick={() => {
          if (isToggleable) {
            onToggle?.();
          }
        }}>
        <div className={clsxm("size-4 shrink-0", iconContainerClassName)}>
          <img src={icon} className={clsxm("size-full object-contain", iconClassName)} />
        </div>
        <span className="bg-linear-(--primary-dark-gradient) bg-clip-text font-semibold text-transparent">{text}</span>
        {isToggleable && (
          <ChevronRight
            className={`text-neutral-black h-3 shrink-0 transition-all duration-150 ${isToggled ? "rotate-[270deg]" : "rotate-90"}`}
          />
        )}
        {onTooltipClick && (
          <QuestionMarkIcon onClick={onTooltipClick} className="inline-block size-4 shrink-0 cursor-pointer" />
        )}
      </div>
      <div className="bg-neutral-grey-light h-[1px] flex-1" />
    </div>
  );
};

export default ProfileSeparator;
